import { api } from "@/lib/api";
import { SI } from "@/lib/sourcing";

export const TPL = `${SI}/message-templates`;
export const TOKENS = [["first_name", "First name"], ["full_name", "Full name"], ["role", "Role"], ["company", "Company"]];

export const tplVars = (c, project) => ({
  first_name: (c?.full_name || "").trim().split(/\s+/)[0] || "",
  full_name: c?.full_name || "",
  role: project?.job?.title || project?.job_title || project?.name || "",
  company: c?.current_employer || c?.current_company || c?.company || "",
});

export const fillTemplate = (text, vars) => String(text || "").replace(/\{(\w+)\}/g, (m, k) => (vars[k] ? vars[k] : m));

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// Turns this candidate's real details back into {placeholders} so a saved template works for anyone.
export const toTokens = (text, vars) => ["full_name", "company", "role", "first_name"].reduce(
  (t, k) => (vars[k] && vars[k].length > 1 ? t.replace(new RegExp(`\\b${esc(vars[k])}\\b`, "g"), `{${k}}`) : t), String(text || ""));

export const listTemplates = () => api.get(TPL).then((r) => r.data?.items || []);

const DAY = 86400000;
// Conversation status from the latest message in the thread.
export const threadStatus = (items) => {
  const last = [...(items || [])].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
  if (!last) return null;
  if (last.direction === "inbound") return { key: "replied", label: "Replied", cls: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" };
  if (["bounced", "failed"].includes(last.status)) return { key: "failed", label: "Not delivered", cls: "border-red-500/40 bg-red-500/10 text-red-300" };
  const days = Math.floor((Date.now() - new Date(last.created_at)) / DAY);
  if (days >= 3) return { key: "no_reply", label: `No reply in ${days} days`, cls: "border-amber-500/40 bg-amber-500/10 text-amber-300" };
  return { key: "awaiting", label: "Awaiting reply", cls: "border-[#8224e3]/40 bg-[#8224e3]/10 text-[#d7b6ff]" };
};

export const MSG_EVENT = "si-messages-changed";
export const emitMessages = (cid) => window.dispatchEvent(new CustomEvent(MSG_EVENT, { detail: cid }));
